import { FormControlLabel, Grid, RadioGroup } from '@mui/material'
import moment from 'moment'
import { ChangeEvent, Fragment, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import InputMask from 'react-input-mask'
import { BaseRadio } from '@Components/Form/BaseRadio/BaseRadio'
import * as _ from 'lodash'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { EAuthReground } from '../../../enum/auth.enum'
import { MCountry, MPOB, MPR, RegroundTypes } from '../../../models/auth.model'
import { ICommonQuery, ISelectOptions } from '../../../models/common.model'
import AuthAction from '../../../store/auth/auth.action'
import CreateProfileLayout from './CreateProfileLayout'

// select options
const noneOption = {
    name: 'None',
    value: '',
}

const raceOptions: ISelectOptions[] = [
    {
        name: 'None',
        value: '',
    },
    {
        name: 'White',
        value: 'White',
    },
    {
        name: 'Asian',
        value: 'Asian',
    },
    {
        name: 'Native Hawaiian',
        value: 'Native Hawaiian',
    },
    {
        name: 'American Indian or Alaskan Native',
        value: 'American Indian or Alaskan Native',
    },
    {
        name: 'Black or African American',
        value: 'Black or African American',
    },
]

const ethnicityOptions: ISelectOptions[] = [
    {
        name: 'None',
        value: '',
    },
    {
        name: 'Hispantic  or Latino',
        value: 'Hispantic  or Latino',
    },
    {
        name: 'Not Hispanic or Latino',
        value: 'Not Hispanic or Latino',
    },
]

const defaultValues: any = {
    POB: {
        city: '',
        email: '',
        ethnicity: '',
        issuingState: '',
        race: '',
        smsApproval: '',
        state: '',
        stateId: '',
        telephone: '',
    },
    PR: {
        address: '',
        city: '',
        country: '',
        state: '',
        zipCode: '',
    },
    PRArray: [
        {
            address: '',
            city: '',
            country: '',
            state: '',
            zipCode: '',
        },
    ],
}

interface ICreateProfileStep2 {
    register: any
    countries: MCountry[]
    POB: MPOB
    PR: MPR
    dynamicReground: any
    setRegister: (registerData: any) => void
    getAuthorization: () => Promise<any>
    registerUser: (userInfo: any) => Promise<any>
    getReground: (type: string, parentId: string, stepTwo?: string) => void
    clearReground: (types: string[]) => void
    getDynamicReground: (
        type: RegroundTypes,
        params: ICommonQuery,
        index: number | undefined
    ) => void
    clearDynamicReground: (
        types: Array<RegroundTypes>,
        index: number,
        deleteReground?: boolean
    ) => void
}

const CreateProfileStep2 = (props: ICreateProfileStep2) => {
    // core section
    const {
        register,
        countries,
        POB,
        PR,
        dynamicReground,
        setRegister,
        getAuthorization,
        registerUser,
        getReground,
        clearReground,
        getDynamicReground,
        clearDynamicReground,
    } = props
    const ac = new AbortController()
    const history = useHistory()
    const classesInput = 'reddit-input w-100 mb-2'
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
    } = useForm({ defaultValues })
    const PRFieldsArray = useFieldArray({ control, name: 'PRArray' })

    // states section
    const [submitted, setSubmitted] = useState(false)

    // hooks section
    useEffect(() => {
        if (!register?.security) return history.push('/register')
        if (!register?.stepOne) return history.push('/create-profile-step-1')
        getReground('COUNTRY', '', 'PR.countries')
        if (!register?.stepTwo) return
        reset({ ...register?.stepTwo })
        return () => {
            ac.abort()
        }
    }, [])

    useEffect(() => {
        // const US = countries?.filter((country) => country?.code === 'US')
        // if (US?.length) getReground('STATE', US?.[0]?.code, 'POB.states')
        if (!countries?.length) getReground('COUNTRY', '')
        getReground('STATE', 'US', 'POB.states')
    }, [countries])

    // functions section
    const onSubmit = (formData: any) => {
        setSubmitted(true)
        const { security, stepOne } = register
        const prResidences = formData?.PRArray?.map((item: any) => {
            let tempStr = ''
            _.each(item, (value) => {
                tempStr += value
            })
            if (!tempStr) return
            return { type: 'PR', ...item }
        }).filter((item: any) => item)
        const newData = { ...register, stepTwo: formData }
        setRegister(newData)
        const body = {
            ...security,
            dob: moment(stepOne?.dob).toISOString(),
            ...stepOne,
            residences: [
                {
                    type: 'POB',
                    ...formData?.POB,
                },
                ...prResidences,
            ],
        }
        body.gender = stepOne?.gender === '' ? null : stepOne?.gender

        getAuthorization().then(() => {
            registerUser(body).then(() => {
                history.push('/login')
            })
        })
    }

    const onHandleSelect = (e: any, type: string, index?: number) => {
        const parentCode = e
        switch (type) {
            case EAuthReground.POB_STATES:
                setValue('POB.city', null)
                clearReground([EAuthReground.POB_CITIES])
                if (!parentCode) return

                getReground('CITY', parentCode, EAuthReground.POB_CITIES)
                break

            case EAuthReground.DYNAMIC_COUNTRIES:
                if (index === null || index === undefined) return
                setValue(`PRArray.${index}.state`, null)
                setValue(`PRArray.${index}.city`, null)
                clearDynamicReground(['STATE', 'CITY'], index)
                if (!parentCode) return
                getDynamicReground('STATE', { parentCode }, index)
                break
            case EAuthReground.DYNAMIC_STATES:
                if (index === null || index === undefined) return
                setValue(`PRArray.${index}.city`, null)
                clearDynamicReground(['CITY'], index)
                if (!parentCode) return
                getDynamicReground('CITY', { parentCode }, index)
                break

            default:
                break
        }
    }

    const handleAddPR = () => {
        PRFieldsArray.append(defaultValues.PRArray[0])
    }

    const handleRemovePR = (index: number) => {
        clearDynamicReground(['COUNTRY', 'STATE', 'CITY'], index, true)
        PRFieldsArray.remove(index)
    }

    // element section
    const PRElements = PRFieldsArray?.fields?.map((pr: any, index: number) => {
        return (
            <Fragment key={pr?.id}>
                <Controller
                    control={control}
                    name={`PRArray.${index}.country`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <BaseCreatableSelect
                            label="Country"
                            options={countries}
                            value={value}
                            onChange={(e: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_COUNTRIES,
                                    index
                                )
                            }}
                            fullWidth
                            className={classesInput}
                            error={errors?.PRArray?.[index]?.country && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'country',
                                'Country'
                            )}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.state`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <BaseCreatableSelect
                            label="State"
                            options={dynamicReground?.states?.[index]}
                            value={value}
                            onChange={(e: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_STATES,
                                    index
                                )
                            }}
                            // inputRef={ref}
                            fullWidth
                            className={classesInput}
                            error={errors?.PRArray?.[index]?.state && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'state',
                                'State'
                            )}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.city`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({ field: { ref, value, onChange } }: any) => (
                        <BaseCreatableSelect
                            label="City"
                            options={dynamicReground?.cities?.[index]}
                            value={value}
                            onChange={(e: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_CITIES,
                                    index
                                )
                            }}
                            // inputRef={ref}
                            fullWidth
                            className={classesInput}
                            error={errors?.PRArray?.[index]?.city && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'city',
                                'City'
                            )}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.zipCode`}
                    defaultValue=""
                    rules={{ minLength: 5 }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <InputMask
                            mask="99999"
                            value={value}
                            onChange={(e: ChangeEvent<any>) => {
                                const validatedValue = e?.target?.value
                                onChange(validatedValue?.replaceAll('_', ''))
                            }}
                            className={classesInput}
                        >
                            {(inputProps: any) => {
                                return (
                                    <RedditTextField
                                        {...inputProps}
                                        inputRef={ref}
                                        label="Zip Code"
                                        variant="filled"
                                        className={classesInput}
                                        error={
                                            errors?.PRArray?.[index]?.zipCode &&
                                            true
                                        }
                                        helperText={FormService.getErrorMessage(
                                            errors?.PRArray?.[index],
                                            'zipCode',
                                            'Zip Code',
                                            'Zip Code should be 5 digit'
                                        )}
                                    />
                                )
                            }}
                        </InputMask>
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.address`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <RedditTextField
                            {...field}
                            value={value}
                            onChange={onChange}
                            inputRef={ref}
                            label="Address"
                            variant="filled"
                            className={classesInput}
                            error={errors?.PRArray?.[index]?.address && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'address',
                                'Address'
                            )}
                            onKeyPress={(e: any) =>
                                CommonService.allowsInput(e, [
                                    'alphabet',
                                    'numeric',
                                    'space',
                                ])
                            }
                        />
                    )}
                />
                {PRFieldsArray?.fields?.length > 1 ? (
                    <div className="text-right">
                        <span
                            className="custom-button-label"
                            onClick={() => handleRemovePR(index)}
                        >
                            Remove
                        </span>
                    </div>
                ) : null}
                <div className="page-divider my-3" />
            </Fragment>
        )
    })

    return (
        <CreateProfileLayout>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-fields-container">
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <p className="text-left profile-headline mb-2">
                                Place of birth U.S.
                            </p>
                            <Controller
                                control={control}
                                name="POB.state"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <BaseCreatableSelect
                                        label="State"
                                        options={POB?.states}
                                        value={value}
                                        onChange={(e: any) => {
                                            onChange(e)
                                            onHandleSelect(e, 'POB.states')
                                        }}
                                        // inputRef={ref}
                                        fullWidth
                                        className={classesInput}
                                        error={errors?.POB?.state && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.state',
                                            'State'
                                        )}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.stateId"
                                defaultValue=""
                                rules={{ minLength: 8 }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <InputMask
                                        mask="a9999999"
                                        value={value}
                                        onChange={(e: ChangeEvent<any>) => {
                                            const validatedValue =
                                                e?.target?.value
                                            onChange(
                                                validatedValue?.replaceAll(
                                                    '_',
                                                    ''
                                                )
                                            )
                                        }}
                                        className={classesInput}
                                    >
                                        {(inputProps: any) => {
                                            return (
                                                <RedditTextField
                                                    {...inputProps}
                                                    inputRef={ref}
                                                    label="State ID#"
                                                    variant="filled"
                                                    className={classesInput}
                                                    error={
                                                        errors?.POB?.stateId &&
                                                        true
                                                    }
                                                    // placeholder="[a-Z]XX-XX-XXXX"
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'POB.stateId',
                                                        'State ID#',
                                                        'State ID# should be [a-Z]XX-XX-XXX'
                                                    )}
                                                />
                                            )
                                        }}
                                    </InputMask>
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.city"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <BaseCreatableSelect
                                        label="City"
                                        options={POB?.cities}
                                        value={value}
                                        onChange={(e: any) => {
                                            onChange(e)
                                            onHandleSelect(e, 'POB.cities')
                                        }}
                                        // inputRef={ref}
                                        fullWidth
                                        className={classesInput}
                                        error={errors?.POB?.city && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.city',
                                            'City'
                                        )}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.issuingState"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <BaseCreatableSelect
                                        label="Issuing State"
                                        options={POB?.states}
                                        value={value}
                                        onChange={onChange}
                                        // inputRef={ref}
                                        fullWidth
                                        className={classesInput}
                                        error={
                                            errors?.POB?.issuingState && true
                                        }
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.issuingState',
                                            'Issuing State'
                                        )}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.ethnicity"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <BaseSelect
                                        label="Ethnicity"
                                        options={ethnicityOptions}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        fullWidth
                                        className={classesInput}
                                        error={errors?.POB?.ethnicity && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.ethnicity',
                                            'Ethnicity'
                                        )}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.race"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange },
                                }: any) => (
                                    <BaseSelect
                                        label="Race"
                                        options={raceOptions}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        fullWidth
                                        className={classesInput}
                                        error={errors?.POB?.race && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.race',
                                            'Race'
                                        )}
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.email"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Email"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.POB?.email && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.email',
                                            'Email'
                                        )}
                                        onKeyPress={(e: any) =>
                                            CommonService.allowsInput(e, [
                                                'alphabet',
                                                'numeric',
                                                'spacial',
                                            ])
                                        }
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="POB.telephone"
                                defaultValue=""
                                rules={{ minLength: 12 }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        inputRef={ref}
                                        label="Telephone"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.POB?.telephone && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'POB.telephone',
                                            'Telephone'
                                        )}
                                        onKeyPress={CommonService.phoneNumber}
                                    />
                                )}
                            />
                            <div className="page-gray-card radio-card">
                                <p className="m-0 gray-text mr-2 w-50">
                                    SMS Approval
                                </p>
                                <Controller
                                    control={control}
                                    name="POB.smsApproval"
                                    defaultValue=""
                                    render={({
                                        field: { onChange, value },
                                    }) => (
                                        // as={
                                        <RadioGroup
                                            className="d-flex flex-row align-items-center flex-nowrap"
                                            value={value || 'false'}
                                            onChange={onChange}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <BaseRadio value="YES" />
                                                }
                                                label={
                                                    <span className="gray-text mr-2">
                                                        YES
                                                    </span>
                                                }
                                                className="m-0"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <BaseRadio value="NO" />
                                                }
                                                label={
                                                    <span className="gray-text mr-2">
                                                        NO
                                                    </span>
                                                }
                                                className="m-0"
                                            />
                                        </RadioGroup>
                                    )}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <p className="text-left profile-headline mb-2">
                                Previous Residence (10 years history)
                            </p>
                            {PRElements}
                            <div className="w-100 text-center">
                                <span
                                    className="custom-button-label"
                                    onClick={handleAddPR}
                                >
                                    Add Another
                                </span>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className="m-auto" style={{ width: 'fit-content' }}>
                    <button
                        type="submit"
                        className="d-block auth-primary-btn mt-3"
                    >
                        Save
                    </button>
                </div>
            </form>
        </CreateProfileLayout>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { register } = state?.auth
    const { countries, POB, PR, dynamicReground } = state?.tempAuth
    return {
        register,
        countries,
        POB,
        PR,
        dynamicReground,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const {
        setRegister,
        getAuthorization,
        registerUser,
        getReground,
        clearReground,
        getDynamicReground,
        clearDynamicReground,
    } = AuthAction
    return {
        setRegister: (registerData: any) =>
            dispatch(setRegister(registerData) as any),
        getAuthorization: () => dispatch(getAuthorization() as any),
        registerUser: (userInfo: any) =>
            dispatch(registerUser(userInfo) as any),
        getReground: (type: string, parentId: string, stepTwo?: string) =>
            dispatch(getReground(type, parentId, stepTwo) as any),
        clearReground: (types: string[]) =>
            dispatch(clearReground(types) as any),
        getDynamicReground: (
            type: RegroundTypes,
            params: ICommonQuery,
            index: number | undefined
        ) => dispatch(getDynamicReground(type, params, index) as any),
        clearDynamicReground: (
            types: Array<RegroundTypes>,
            index: number,
            deleteReground?: boolean
        ) =>
            dispatch(clearDynamicReground(types, index, deleteReground) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfileStep2)
